(ns bec-core.cljs.views.machines
  (:require [re-frame.core :as rf]
            [reagent.core :as r]
            [bec-cljs-common.components.icon :refer [icon angle-down]]
            [bec-cljs-common.components.input :as input]
            [bec-cljs-common.components.button :as button]
            [bec-cljs-common.utils.formatting :as fmt]
            ["react-beautiful-dnd" :refer [DragDropContext Droppable Draggable]]
            [clojure.string :as s]
            [bec-cljs-common.utils.interop :as interop]))

(defonce current-sort (r/atom (or (interop/local-storage :get-item :machines-current-sort) {})))

(defn make-into-uuid [s] ;; Helper function until all uuids are fixed to be uuids and not strings
  (if (string? s)
    (uuid s)
    s))

(defn move-index [v index-1 index-2]
  (when v
    (if-not (= (- index-1 index-2) 0)
      (let [move-index-up? (> index-1 index-2)
            v (if move-index-up? (vec (reverse v)) v)
            first-index (if move-index-up? (- (count v) (inc index-1)) index-1)
            second-index (if move-index-up? (- (count v) (inc index-2)) index-2)
            part-1 (subvec v 0 first-index)
            part-2-temp (subvec v first-index (inc second-index))
            move-item (first part-2-temp)
            part-2 (vec (reverse (pop (vec (reverse part-2-temp)))))
            part-3 (subvec v (inc second-index))
            merged-vector (into (into (into part-1 part-2) [move-item]) part-3)
            final-vector (if move-index-up? (vec (reverse merged-vector)) merged-vector)]
        final-vector)
      v)))

(def filter-categories
  {:connected
   {:filter-key :connected
    :initial-index 0
    :filter-name "Is connected?"
    :get-data-fn (fn [data]
                   {:custom-component
                    (if (:online? (get (:observed-state-presence data) (make-into-uuid (:machine-uuid (:config (:machine data))))))
                      [:div {:style {:color "var(--success)"}}
                       [:span "Yes"]]
                      [:div
                       {:style {:color "var(--danger)"}}
                       [:span "No"]])})}
   :display-name
   {:filter-key :display-name
    :initial-index 1
    :filter-name "Display name"
    :get-data-fn (fn [data] {:data (get-in (:machine data) [:config :display-name] nil)})
    :sort-by-path [:config :display-name]}
   :customer-service
   {:filter-key :customer-service
    :initial-index 2
    :filter-name "Service requested?"
    :get-data-fn (fn [data]
                   {:custom-component
                    (let [state (get-in (:machine data) [:bec-clj-common :customer-service :state] nil)]
                      (if (= state :active)
                        [:div {:style {:color "var(--warning)"}}
                         [icon [:i.far.fa-comments]]
                         [:span "Yes"]]
                        [:div
                         [icon [:i.far.fa-comments]]
                         [:span "No"]]))})
    :sort-by-path [:bec-clj-common :customer-service :state]}
   :request-start-time
   {:filter-key :request-start-time
    :initial-index 3
    :filter-name "Service start time"
    :get-data-fn (fn [data]
                   {:custom-component
                    [:div
                     [:span
                      {:style {:font-weight "bold"}}
                      (str
                        (fmt/format-tick-ts
                          (get-in (:machine data) [:bec-clj-common :customer-service :request-start-time] nil)
                          {:time-zone (get-in (:machine data) [:config :time-zone] nil)
                           :locale (get-in (:machine data) [:config :locale] nil)})
                        " - ")]
                     [:span
                      (fmt/format-tick-ts
                        (get-in (:machine data) [:bec-clj-common :customer-service :request-start-time] nil)
                        {:date? true
                         :time-zone (get-in (:machine data) [:config :time-zone] nil)
                         :locale (get-in (:machine data) [:config :locale] nil)})]]})
    :sort-by-path [:bec-clj-common :customer-service :request-start-time]}
   :request-end-time
   {:filter-key :request-end-time
    :initial-index 4
    :filter-name "Service end time"
    :get-data-fn (fn [data]
                   {:custom-component
                    [:div
                     [:span
                      {:style {:font-weight "bold"}}
                      (str
                        (fmt/format-tick-ts
                          (get-in (:machine data) [:bec-clj-common :customer-service :request-end-time] nil)
                          {:time-zone (get-in (:machine data) [:config :time-zone] nil)
                           :locale (get-in (:machine data) [:config :locale] nil)})
                        " - ")]
                     [:span
                      (fmt/format-tick-ts
                        (get-in (:machine data) [:bec-clj-common :customer-service :request-end-time] nil)
                        {:date? true
                         :time-zone (get-in (:machine data) [:config :time-zone] nil)
                         :locale (get-in (:machine data) [:config :locale] nil)})]]})
    :sort-by-path [:bec-clj-common :customer-service :request-end-time]}
   :session-start
   {:filter-key :session-start
    :initial-index 5
    :filter-name "Session start time"
    :get-data-fn (fn [data]
                   {:custom-component
                    [:div
                     [:span
                      {:style {:font-weight "bold"}}
                      (str
                        (fmt/format-tick-ts
                          (get-in (:machine data) [:bec-clj-common :session :start-ts] nil)
                          {:time-zone (get-in (:machine data) [:config :time-zone] nil)
                           :locale (get-in (:machine data) [:config :locale] nil)})
                        " - ")]
                     [:span
                      (fmt/format-tick-ts
                        (get-in (:machine data) [:bec-clj-common :session :start-ts] nil)
                        {:date? true
                         :time-zone (get-in (:machine data) [:config :time-zone] nil)
                         :locale (get-in (:machine data) [:config :locale] nil)})]]})
    :sort-by-path [:bec-clj-common :session :start-ts]}
   :session-end
   {:filter-key :session-end
    :initial-index 6
    :filter-name "Session end time"
    :get-data-fn (fn [data]
                   {:custom-component
                    [:div
                     [:span
                      {:style {:font-weight "bold"}}
                      (str
                        (fmt/format-tick-ts
                          (get-in (:machine data) [:bec-clj-common :session :end-ts] nil)
                          {:time-zone (get-in (:machine data) [:config :time-zone] nil)
                           :locale (get-in (:machine data) [:config :locale] nil)})
                        " - ")]
                     [:span
                      (fmt/format-tick-ts
                        (get-in (:machine data) [:bec-clj-common :session :end-ts] nil)
                        {:date? true
                         :time-zone (get-in (:machine data) [:config :time-zone] nil)
                         :locale (get-in (:machine data) [:config :locale] nil)})]]})
    :sort-by-path [:bec-clj-common :session :end-ts]}
   :session-remaining-seconds
   {:filter-key :session-remaining-seconds
    :initial-index 7
    :filter-name "Session remaining time"
    :get-data-fn (fn [data]
                   {:data
                    (fmt/readable-duration
                      {:seconds (get-in (:machine data) [:bec-clj-common :session :remaining-seconds] nil)
                       :short? true})})
    :sort-by-path [:bec-clj-common :session :remaining-seconds]}
   :time-zone
   {:filter-key :time-zone
    :initial-index 8
    :filter-name "Time zone"
    :get-data-fn (fn [data] {:data (get-in (:machine data) [:config :time-zone] nil)})
    :sort-by-path [:config :time-zone]}
   :open-admin-viewport
   {:filter-key :open-admin-viewport
    :initial-index 9
    :filter-name "Admin view"
    :get-data-fn (fn [data] {:data (make-into-uuid (:machine-uuid (:config (:machine data))))})}
   :app-category
   {:filter-key :app-category
    :initial-index 10
    :filter-name "Game type"
    :get-data-fn (fn [data] {:data (get-in (:machine data) [:config :app-category] nil)})
    :sort-by-path [:config :app-category]}
   :hostname
   {:filter-key :hostname
    :initial-index 11
    :filter-name "Hostname"
    :get-data-fn (fn [data] {:data (get-in (:machine data) [:config :hostname] nil)})
    :sort-by-path [:config :hostname]}
   :wg-ip
   {:filter-key :wg-ip
    :initial-index 12
    :filter-name "Wireguard IP"
    :get-data-fn (fn [data] {:data (get-in (:machine data) [:config :wg-ip] nil)})
    :sort-by-path [:config :wg-ip]}})

(defonce filter-category-keys
  (r/atom
    (or
      (interop/local-storage :get-item :machines-filter-category-keys)
      (reduce
        (fn [result v]
          (conj result (:filter-key v)))
        []
        (sort-by :initial-index (vals filter-categories))))))

(defn message-box [props]
  [:div.message (when (map? props) props)
   (into [:div.message-header]
     (r/children (r/current-component)))])

(defn information [& [props]]
  (let [machines (:selected-machines props)
        active-customer-service-count @(rf/subscribe [:observed-state-customer-service-active-count])]
    [:div.fade-in
     {:style {"--fade-in-duration" "1000ms"}}
     [:section.hero
      {:class (if (> active-customer-service-count 0) "is-warning" "is-primary")
       :style {:transition "background-color calc(4 * var(--transition-duration)) ease"}}
      [:div.hero-body
       [:div.container
        [:p.title "Service info"]
        [:p.subtitle (if (empty? machines)
                       "No machines selected"
                       (if (> active-customer-service-count 0)
                         (str active-customer-service-count " has called customer service")
                         "No service has been called"))]]]]
     [:div.container.is-fluid
      {:style {:margin-top "1.5rem"
               :display "flex"
               :flex-direction "column"
               :justify-content "center"
               :align-items "center"}}
      [:div
       {:style {:display "flex"
                :justify-content "center"
                :flex-wrap "wrap"}}
       [:span.tag.is-danger
        {:style {:margin "0 1.5rem 1.5rem 1.5rem"
                 :min-width "8rem"}}
        "Offline"]
       [:span.tag.is-info
        {:style {:margin "0 1.5rem 1.5rem 1.5rem"
                 :min-width "8rem"}}
        "No service"]
       [:span.tag.is-warning
        {:style {:margin "0 1.5rem 1.5rem 1.5rem"
                 :min-width "8rem"}}
        "Service called"]]
      (if (empty? machines)
        [button/button
         {:class "is-primary"
          :on-click #(rf/dispatch [:select-view :machines])}
         "Go to machine selection"]
        (into
          [:div
           {:style {:display "flex"
                    :justify-content "center"
                    :flex-wrap "wrap"}}]
          (map-indexed
            (fn [index machine]
              (let [service-active? (= (get-in machine [:bec-clj-common :customer-service :state] nil) :active)
                    is-online? (:online? (get (:observed-state-presence props) (make-into-uuid (:machine-uuid (:config machine)))))]
                [message-box
                 {:key index
                  :class (cond
                           service-active? "is-warning"
                           is-online? "is-info"
                           :else "is-danger")
                  :style {:width "20rem"
                          :margin "0 0.5rem 1rem 0.5rem"
                          :height "fit-content"
                          :transition "background-color calc(2 * var(--transition-duration)) ease"}}
                 (:display-name (:config machine))
                 [button/glowing-icon-button
                  {:button-style {:display "block"}
                   :style {:color "inherit"}
                   :on-click (fn []
                               (swap! input/variables assoc-in [:checkbox (make-into-uuid (:machine-uuid (:config machine)))] false)
                               (when (= (count machines) 1)
                                 (rf/dispatch [:select-view :machines])))}
                  [:i.fas.fa-times-circle]]]))
            machines)))]]))

(defn pos-settings []
  (let [keypad-id "machine-pos-iframe-url"
        keypad-props @(rf/subscribe [:keypad keypad-id])]
    [:div.panel-body.fade-in
     [:table.table
      {:style {:width "100%"}}
      [:tbody
       [:tr
        [:td
         {:style {:padding 0}}
         [input/switch
          {:class "is-rounded"
           :outer-style {:border-radius "6px"}}
          "Toggle POS iframe"]]
        [:td
         {:style {:vertical-align "bottom"}}
         [button/button
          {:class "is-danger is-fullwidth is-outlined"
           :style {:margin 0}
           :on-click #(rf/dispatch [:core-shared-state [:common :darts-game-server :hello] "Hello"])}
          "Reset"]]]
       [:tr
        [:td
         {:style {:padding 0}}  
         [:div.panel-block
          [:div.field
           {:style {:width "100%"
                    :text-align "start"}}
           [:div.field.label.is-normal
            [:label "POS iframe URL"]]
           [:div.field-body
            [:div.field
             [:div.control
              {:style {:display "flex"}}
              [input/input
               {:id keypad-id
                :type "text"
                :placeholder "POS iframe URL"
                :value (:input keypad-props)
                :on-change #(rf/dispatch [:keyboard-button-press
                                          {:keypad-id keypad-id
                                           :input (-> % .-target .-value)}])}]]]]]]]
        [:td
         {:style {:vertical-align "bottom"}}
         [button/button
          {:class "is-danger is-fullwidth is-outlined"
           :style {:margin 0}
           :on-click #(rf/dispatch [:core-shared-state [:common :darts-game-server :hello] "Hello"])}
          "Reset"]]]]]]))

(defn setting-box [& [props]]
  (let [selected-setting (:selected-setting props)
        setting-title (:title props)
        setting-subtitle (:subtitle props)
        setting-type (:setting-type props)
        setting-active? (= selected-setting setting-type)
        setting-usable? (= setting-type :pos)
        checkbox @(rf/subscribe [:checkbox])]
    [:div.tile.fade-in
     {:class (if setting-active? "is-12" "is-6")
      :style {:display (when (and (not setting-active?) selected-setting) "none")}}
     [:div.tile.is-parent.is-vertical
      [:div.tile.is-child.box
       {:style {:position "relative"
                :width "100%"
                :filter "drop-shadow(0px 0px 0.0625rem var(--blue))"
                :text-align "center"}}
       [:div
        {:style {:display "flex"
                 :flex-direction "column"
                 :justify-content "space-between"
                 :height "100%"}}
        [:h1.title.is-spaced
         {:style {:font-size (when setting-active? "1.5rem")
                  :margin-bottom (when setting-active? "0.25rem")
                  :transition "font-size 250ms"}}
         setting-title]
        [:p.subtitle
         {:style {:font-size (when setting-active? "1rem")
                  :transition "font-size 250ms"}}
         setting-subtitle]
        (when setting-active?
          (case setting-type
            :pos [pos-settings]
            :rebranding [pos-settings]
            :seasonal-decorations [pos-settings]
            :marketing [pos-settings]))
        (if setting-active?
          [:div.panel-block.fade-in
           {:style {:overflow "auto"
                    :margin-top "1.5rem"}}
           [button/button
            {:class "is-fullwidth"
             :style {:margin "0.25rem 0.5rem 0.25rem 0"}
             :on-click #(rf/dispatch [:select-view :machines {:sub-view :settings}])}
            "Cancel"]
           [button/button
            {:class "is-success is-outlined is-fullwidth"
             :style {:margin "0.25rem 0 0.25rem 0.5rem"}
             :on-click #(rf/dispatch [:core-shared-state [:common :darts-game-server :hello] "Hello"])}
            "Confirm"]]
          [button/button
           {:class "is-link is-outlined is-fullwidth"
            :style {:margin "0"}
            :disabled (not setting-usable?)
            :on-click #(rf/dispatch [:select-view :machines {:sub-view :settings
                                                           :selected-setting setting-type}])}
           "Open"])]]]]))

(defn settings-options [& [props]]
  [:div.fade-in
   {:style {"--fade-in-duration" "1000ms"}}
   [:div.tile.is-ancestor
    {:style {:position "relative"}}
    [setting-box (merge props
                   {:title "POS"
                    :subtitle "Toggle POS and change iframe POS URL."
                    :setting-type :pos})]
    [setting-box (merge props
                   {:title "Rebranding"
                    :subtitle "Toggle rebranding, adjust color schemes and upload brand material."
                    :setting-type :rebranding})]]
   [:div.tile.is-ancestor
    {:style {:position "relative"}}
    [setting-box (merge props
                   {:title "Seasonal decorations"
                    :subtitle "Toggle seasonal decorations, change timings and upload new seasonal material."
                    :setting-type :seasonal-decorations})]
    [setting-box (merge props
                   {:title "Marketing"
                    :subtitle "Toggle promotions on and off, change timings and upload new promotional material."
                    :setting-type :marketing})]]])

(defn settings [& [props]]
  (let [machines (:selected-machines props)]
    [:div.fade-in
     {:style {"--fade-in-duration" "1000ms"}}
     [:div.container.is-fluid
      {:style {:margin "1.5rem 0"}}
      (into
        [:div
         {:style {:text-align "center"
                  :margin-bottom "1.5rem"}}
         [:h1.title.is-spaced.is-1
          "Machine settings"]
         [:p.subtitle
          "Changes will apply to the machines below"]
         (map
           (fn [machine]
             [:span.tag.is-info
              {:key (:machine-uuid (:config machine))
               :style {:margin "0 0.25rem 0.25rem 0"}}
              (:display-name (:information machine))
              [:button.is-clickable.glows
               {:style {:margin-left "0.25rem"}
                :on-click (fn []
                            (swap! input/variables assoc-in [:checkbox (make-into-uuid (:machine-uuid (:config machine)))] false)
                            (when (= (count machines) 1)
                              (rf/dispatch [:select-view :machines])))}
               [:i.fas.fa-times-circle]]])
           machines)])
      [settings-options props]]]))

(defn actions [& [props]]
  [:div.fade-in
   {:style {"--fade-in-duration" "1000ms"}}
   [:div.container.is-fluid
    {:style {:margin-top "1.5rem"}}
    [:button.button.has-margin
     {:on-click #(rf/dispatch [:select-view :dashboard])}
     "Go to dashboard"]
    [:button.button.has-margin
     {:on-click #(rf/dispatch [:select-view :home])}
     "Show home"]
    [:div.tile.is-ancestor
     [:div.tile.is-4
      [:div.tile
       [:div.tile.is-parent.is-vertical
        [:article.tile.is-child.box.is-clickable
         {:on-click #(rf/dispatch [:select-view :machine {:sub-view :information}])}
         [:div
          {:style {:display "flex"
                   :justify-content "center"
                   :align-items "center"
                   :flex-direction "column"
                   :text-align "center"}}
          [:div.box.is-rounded
           [icon
            {:size "5rem"}
            [:i.fas.fa-info]]]
          [:h1.title "Information"]]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:on-click #(rf/dispatch [:select-view :machine {:sub-view :actions}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          [icon
           {:size "5rem"}
           [:i.fas.fa-tools]]]
         [:h1.title "Actions"]]]]]
     [:div.tile.is-4
      [:div.tile.is-parent.is-vertical
       [:article.tile.is-child.box.is-clickable
        {:on-click #(rf/dispatch [:select-view :machine {:sub-view :settings}])}
        [:div
         {:style {:display "flex"
                  :justify-content "center"
                  :align-items "center"
                  :flex-direction "column"
                  :text-align "center"}}
         [:div.box.is-rounded
          [icon
           {:size "5rem"}
           [:i.fas.fa-cog]]]
         [:h1.title "Settings"]]]]]]]])

(defonce dropdown-active? (r/atom nil))

(defn sortable-th [& [props]]
  [:th
   {:key (:key props)
    :style {:padding-left 0}}
   [button/button
    {:style {:border "none"
             :margin 0
             :padding "0.5em 0.75em"
             :justify-content "start"
             :font-weight "bold"}
     :class "is-fullwidth"
     :on-click (:on-click props)}
    (into
      [:span]
      (r/children (r/current-component)))
    (if (nil? (:current-sort props))
      [icon
       [:i.fas.fa-sort]]
      [angle-down {:icon-class "fas fa-sort-down"
                   :active? (:reverse-sort? (:current-sort props))}])]])

(defn machine-selection [& [props]]
  (let [machines (if (first (vals @current-sort))
                   (let [sorted-machines (sort-by #(get-in % (:sort-by-path (first (vals @current-sort)))) 
                                           (:machines props))]
                     (if (:reverse-sort? (first (vals @current-sort)))
                       (reverse sorted-machines)
                       sorted-machines)) 
                   (:machines props))
        observed-state-presence (:observed-state-presence props)
        checkboxes @(rf/subscribe [:checkbox])
        loading @(rf/subscribe [:loading])]
    [:div.panel-body
     {:style {:height "calc(100vh - 18rem)"
              :min-height "20vh"
              :overflow "auto"}}
     [:table.table
      {:style {:width "100%"}}
      [:thead
       {:style {:position "sticky"
                :top "-1px"
                :background "var(--scheme-main)"
                :z-index "1"}}
       (into
         [:tr
          [:th
           [:span "Select"]]]
         (map-indexed
           (fn [index filter-key]
             (let [checked? (get checkboxes filter-key)
                   filter-cat-props (get filter-categories filter-key)]
               (when (not (false? checked?))
                 (if (:sort-by-path filter-cat-props)
                   [sortable-th
                    {:key (str "filter-th-" index)
                     :on-click (fn []
                                 (let [current-sort-val {filter-key
                                                         {:sort-by-path (:sort-by-path filter-cat-props)
                                                          :reverse-sort? (not (:reverse-sort? (get @current-sort filter-key)))}}]
                                   (reset! current-sort current-sort-val)
                                   (rf/dispatch [:local-storage :set-item :machines-current-sort current-sort-val])))
                     :current-sort (get @current-sort filter-key)}
                    (:filter-name filter-cat-props)]
                   [:th {:key (str "filter-th-" index)}
                    [:span (:filter-name filter-cat-props)]]))))
           @filter-category-keys))]
      (into
        [:tbody]
        (map-indexed
          (fn [index-1 machine]
            (into
              [:tr {:key (str "filter-tr-" index-1)}
               [:td
                {:style {:padding 0}}
                [input/checkbox
                 {:checkbox-key (make-into-uuid (:machine-uuid (:config machine)))
                  :class "is-rounded"
                  :outer-style {:border-radius 0}}]]]
              (map-indexed
                (fn [index-2 filter-key]
                  (let [checked? (get checkboxes filter-key)
                        filter-cat-props (get filter-categories filter-key)]
                    (when (not (false? checked?))
                      (let [filter-props (when (fn? (:get-data-fn filter-cat-props))
                                           ((:get-data-fn filter-cat-props) {:machine machine 
                                                                             :observed-state-presence observed-state-presence}))
                            filter-data (:data filter-props)
                            custom-component (:custom-component filter-props)
                            td-key (str "filter-td-" index-2)]
                        (cond
                          (= filter-key :open-admin-viewport)
                          [:td {:key td-key}
                           [button/button
                            {:loading? (:open-admin-viewport loading)
                             :on-click #(rf/dispatch [:open-admin-viewport filter-data])}
                            "Open admin"]]
                          :else
                          [:td {:key td-key}
                           (or custom-component filter-data)])))))
                @filter-category-keys)))
          machines))]]))

(defn filter-dropdown-options [props]
  (r/create-class
    {:component-did-mount
     (fn []
       )
     :component-did-update
     (fn [this]
       )
     :display-name "teams-drag-and-drop"
     :reagent-render
     (fn [props]
       (let []
         [:> DragDropContext
          {:onDragEnd (fn [event]
                        (try
                          (when (and event.destination event.source)
                            (let [re-arranged-filter-category-keys (move-index @filter-category-keys
                                                                     event.source.index event.destination.index)]
                              (reset! filter-category-keys re-arranged-filter-category-keys)
                              (rf/dispatch [:local-storage :set-item :machines-filter-category-keys
                                            re-arranged-filter-category-keys])))
                          (catch js/Error e)))}
          [:> Droppable {:key "filter-container" :droppable-id "filter-container"}
           (fn [provided snapshot]
             (r/as-element
               (conj
                 (into
                   [:div (merge
                           {:ref (.-innerRef provided)}
                           (js->clj (.-droppableProps provided)))]
                   (map-indexed
                     (fn [index filter-key]
                       (let [filter-cat-props (get filter-categories filter-key)]
                         [:> Draggable
                          {:key (name filter-key)
                           :index index
                           :draggable-id (name filter-key)}
                          (fn [provided snapshot]
                            (r/as-element
                              [:div (merge {:ref (.-innerRef provided)}
                                      (js->clj (.-draggableProps provided)))
                               [input/checkbox
                                {:checkbox-key filter-key
                                 :checked true
                                 :class "is-rounded"
                                 :outer-style {:min-width "15rem"}}
                                [:div
                                 {:style {:display "flex"
                                          :justify-content "space-between"
                                          :align-items "center"
                                          :width "100%"}}
                                 (:filter-name filter-cat-props)
                                 [icon
                                  (js->clj (.-dragHandleProps provided))
                                  [:i.fas.fa-arrows-up-down]]]]]))]))
                     @filter-category-keys))
                 (.-placeholder provided))))]]))}))

(defn filter-dropdown []
  [button/dropdown
   {:button-label "Filters"
    :id "dropdown-menu"
    :class "is-right"
    :style {:margin "0 0 0 0.25rem"
            :min-width "6rem"}}
   [filter-dropdown-options]])

(defn filter-dropdown2 []
  (into
    [button/dropdown
     {:button-label "Filters"
      :id "dropdown-menu"
      :class "is-right"
      :style {:margin "0 0 0 0.25rem"
              :min-width "6rem"}}]
    (map-indexed
      (fn [index filter-key]
        (let [filter-cat-props (get filter-categories filter-key)]
          [input/checkbox
           {:key (str "dropdown-filter-" index)
            :checkbox-key filter-key
            :class "is-rounded"
            :outer-class "dropdown-item"}
           (:filter-name filter-cat-props)]))
      @filter-category-keys)))

(defn list-view [& [props]]
  (let [keypad-props @(rf/subscribe [:keypad "machine-search-bar-input"])
        select-all? (not (= (count (:machines props)) (count (:selected-machines props))))]
    [:div.fade-in
     {:style {"--fade-in-duration" "1000ms"}}
     [:div.container.is-fluid
      [:section.section
       [:nav.panel.is-primary
        [:div.panel-heading
         {:style {:display "flex"
                  :justify-content "center"}}
         [:p (if (> (count (:selected-machines props)) 0)
               (str "Selected " (count (:selected-machines props)))
               "Select")]]
        [:div.panel-block
         {:style {:border-bottom "none"}}
         [button/button
          {:style {:margin "0 0.25rem 0 0"
                   :min-width "6rem"}
           :on-click (fn []
                       (doseq [machine (:machines props)]
                         (swap! input/variables assoc-in [:checkbox (make-into-uuid (:machine-uuid (:config machine)))] select-all?)))}
          (if select-all? "Select all" "Deselect all")]
         [:div.control.has-icons-left
          [input/input
           {:id "machine-search-bar-input"
            :type "text"
            :placeholder "Search"
            :value (:input keypad-props)
            :on-change #(rf/dispatch [:keyboard-button-press
                                      {:keypad-id "machine-search-bar-input"
                                       :input (-> % .-target .-value)}])}]
          [:span.icon.is-left
           [:i.fas.fa-search
            {:aria-hidden true}]]]
         [filter-dropdown]]
        [machine-selection props]
        [:div.panel-block
         {:style {:overflow "auto"}}
         [button/button
          {:class "is-link is-outlined is-fullwidth"
           :style {:margin "0.25rem 0.5rem"}
           :disabled true}
          "Actions"]
         [button/button
          {:class "is-link is-outlined is-fullwidth"
           :style {:margin "0.25rem 0.5rem"}
           :disabled (empty? (:selected-machines props))
           :on-click #(rf/dispatch [:select-view :machines {:sub-view :information}])}
          "Information"]
         [button/button
          {:class "is-link is-outlined is-fullwidth"
           :style {:margin "0.25rem 0.5rem"}
           :disabled true #_(empty? (:selected-machines props))
           :on-click #(rf/dispatch [:select-view :machines {:sub-view :settings}])}
          "Settings"]]]]]]))

(defn view [& [props]]
  (let [checkboxes @(rf/subscribe [:checkbox])
        machines @(rf/subscribe [:machine-search])
        observed-state-presence @(rf/subscribe [:observed-state-presence])
        selected-machines (filter #(get checkboxes (make-into-uuid (:machine-uuid (:config %)))) machines)
        extra-props {:machines machines
                     :observed-state-presence observed-state-presence
                     :selected-machines selected-machines}]
    (case (:sub-view props)
      :information [information (merge props extra-props)]
      :settings [information (merge props extra-props)] #_[settings (merge props extra-props)]
      :actions [information (merge props extra-props)] #_[actions (merge props extra-props)]
      [list-view (merge props extra-props)])))